const MENU_DEFINITION_TASKS_SORTING_CRITERIA = {
  MODIFIED_DATE: 'MODIFIED_DATE',
}

export default MENU_DEFINITION_TASKS_SORTING_CRITERIA
